import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Vue  = require('vue/dist/vue.min');
window._    = require('lodash');

Vue.config.productionTip = false;

window.app = new Vue({
    el: '#app',
    data: {
        price: price || null,
        total: price || null,
        discount: 0,
        licenses: licenses || {},
        selectedLicense: null,
        couponCode: '',
        _token: null
    },
    methods: {
        toggle: function(selector, cls = '')
        {
            var cls = cls.length ? cls : 'visible';
            var status = $(`${selector}`).hasClass(`${cls}`);

            $(selector).toggleClass(cls, !status);
        },
        setItemPrice: function(licenseId)
        {
            let itemId_ = itemId || arguments[1] || null;

            console.log(itemId_)

            this.price = this.licenses[licenseId];

            $('.ui.dimmer').dimmer('show')

            Vue.nextTick(()=>
            {
                if(!loggedIn)
                {
                    location.href = `/login?redirect=${location.href}`;

                    return;
                }

                $.post('/checkout', {itemId: itemId_, licenseId, itemType, _token: this._token})
                .done(function(response)
                {
                    if(response.status)
                    {
                        location.href = `/checkout?redirect=${location.href}`;
                        return;   
                    }
                    else
                    {
                        alert(response.message);   
                    }
                })

                $('.ui.dimmer').dimmer('hide')
            })
        },
        applyCoupon: function(e)
        {
            if(!loggedIn)
            {
                location.href = `/login?redirect=${location.href}`;

                return;
            }

            if(!this.couponCode.length)
            {
                return;
            }

            let couponCode = this.couponCode.trim();

            $.post('/checkout', {couponCode, itemId, licenseId, itemType, _token: this._token})
            .done((response) =>
            {
                if(response.status)
                {
                    this.price    = response.item.price.toFixed(2);
                    this.discount = Number(response.item.coupon.value).toFixed(2);
                    this.total    = Number(this.price - this.discount).toFixed(2);
                }
                else
                {
                    this.discount = 0;
                    this.total    = this.price;
                }

                $('#checkout .coupon .message').text(response.message).toggleClass('d-none', false);
            })
        }
    },
    mounted: function()
    {
        this._token = $('meta[name="csrf-token"]').attr('content');
    }
});



$(function()
{
    if(store.get('cookieAccepted') !== true)
    {
        setTimeout(() =>
        {
            $('#cookie').transition({
              animation : 'slide up',
              duration  : 500
            });
        }, 3000)

        $('#cookie .button.accept').on('click', function()
        {
          store.set('cookieAccepted', true)
          
          $('#cookie').transition({
            animation : 'fade',
            duration  : 800
          });     
        })
    }


    $('#body .item-body .columns .column.left .ui.segment .share .right.menu .item').on('click', function()
    {
      $.post('/update_social_shares', {media: $(this).data('media'), item_id: itemId, _token: app._token})
      .done(data =>
      {
        if(data.status)
        {
          window.open(data.url, '_blank');
        }
      })
    })


    $('.user-coupon i.close').on('click', function()
    {
        $(this).closest('.user-coupon').hide();
    })

    $('div[data-tab="reviews"] .ui.rating').rating({
        initialRating: 0,
        maxRating: 5,
        onRate: (rating) =>
        {
            $('div[data-tab="reviews"] input[name="rating"]').val(rating)
        }
    })

    $('#checkout .terms .text').on('click', function()
    {
        $(this).toggleClass('visible', !$(this).hasClass('visible'));

        $('#checkout .terms .details').css('display', $(this).hasClass('visible') ? 'block' : 'none')
    })

    $('#checkout .coupon .text').on('click', function()
    {
        $("#checkout .coupon .input").toggleClass('visible', !$("#checkout .coupon .input").hasClass('visible'));
    })

    $('#checkout .payment-methods .buttons .button').on('click', function()
    {
        $(this).toggleClass('active', true).siblings('.button').toggleClass('active', false);

        $('input[type="radio"]', this).prop('checked', true);
    })

    $('.ui.message i.close').on('click', function()
    {
        $(this).closest('.message').remove();
    })

    $('#profile img.avatar').on('click', function()
    {
        $('input[name="avatar"]').click();
    })

    $('input[name="avatar"]').on('change', function()
    {
        let file = $(this)[0].files[0];

        var reader  = new FileReader();

        if(/^image\/(jpeg|jpg|ico|png|svg\+xml)$/.test(file.type))
        {
            reader.addEventListener("load", function() {
                $('#profile img.avatar').attr('src', reader.result);
            }, false);

            if(file)
            {
                reader.readAsDataURL(file);
            }
        }
        else
        {
            alert('File type not allowed!');

            $(this).val('');
        }
    })

    $('[vhidden]').css('visibility', 'visible')
})